import { render, staticRenderFns } from "./GoalPage.vue?vue&type=template&id=06553638&"
import script from "./GoalPage.vue?vue&type=script&lang=js&"
export * from "./GoalPage.vue?vue&type=script&lang=js&"
import style0 from "./GoalPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports